const NAV_ITEM_TYPES = ['nav', 'quick-entry', 'tool-grid', 'home-grid'] as const

const PRODUCT_LIST_TYPES = [
  'product-list',
  'ticketing-product-list',
  'erp-product-list',
  'market-product-list',
  'shop-list',
] as const

const RECORD_LIST_TYPES = [
  ...NAV_ITEM_TYPES,
  'category-tabs',
  ...PRODUCT_LIST_TYPES,
  'fortune-tools',
  'live-list',
  'live-cards',
  'content-list',
  'expert-list',
  'message-list',
  'order-list',
  'erp-order-list',
  'alumni-service-list',
  'gongzheng-service-list',
  'pet-service-list',
] as const

const CMS_LIST_TYPES = [
  'cms-banner',
  'cms-feed',
  'cms-grid-entries',
  'cms-site-grid',
  'cms-catalog-tree',
  'cms-catalog-list',
] as const

const STATIC_ITEM_NAV_TYPES = ['banner', ...RECORD_LIST_TYPES] as const

function includesType(list: readonly string[], type: string): boolean {
  return list.includes(String(type))
}

export function isProductListType(type: string): boolean {
  return includesType(PRODUCT_LIST_TYPES, type)
}

export function isRecordListType(type: string): boolean {
  return includesType(RECORD_LIST_TYPES, type)
}

export function isCmsListType(type: string): boolean {
  return includesType(CMS_LIST_TYPES, type)
}

export function supportsStaticItemNavigation(type: string): boolean {
  return includesType(STATIC_ITEM_NAV_TYPES, type)
}
